var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"warn"},[_c('div',{staticClass:"warn-title"},[_c('svg-icon',{staticClass:"warn-title-icon",attrs:{"name":"warn","size":"12"}}),_c('div',[_vm._v("审核意见")])],1),_c('div',[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }